/* eslint-disable react/require-default-props */
/* eslint-disable react/no-danger */
/* eslint-disable @next/next/no-img-element */
import Carousel from '../layout/HeroSlider/Carousel'

const EventHero = ({ images }: { images: Array<string> }) =>
  images.length > 0 ? (
    <section>
      <div className="relative">
        <div
          className="absolute inset-x-0 bottom-0 h-1/2 bg-gray-50"
          style={{
            backgroundImage: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='4' height='4' viewBox='0 0 4 4'%3E%3Cpath fill='%23164e63' fill-opacity='0.24' d='M1 3h1v1H1V3zm2-2h1v1H3V1z'%3E%3C/path%3E%3C/svg%3E")`,
          }}
        />
        <div className="max-w-7xl mx-auto sm:px-6 lg:px-8 pb-4">
          <div className="ltr-grid relative shadow-xl sm:rounded-2xl sm:overflow-hidden h-96 flex justify-center items-center">
            <div className="absolute inset-0 ">
              <Carousel images={images} />
              <div className="absolute inset-0 bg-gradient-to-r from-primary to-secondary mix-blend-multiply " />
            </div>
          </div>
        </div>
      </div>
    </section>
  ) : null

export default EventHero
